import { RouterProvider } from "react-router-dom";

import { router } from "@/app/router";
import { AuthSessionProvider } from "@/shared/auth/useAuthSession";
import { LanguageProvider } from "@/shared/i18n/LanguageContext";

export function App() {
  return (
    <LanguageProvider>
      <AuthSessionProvider>
        <RouterProvider router={router} />
      </AuthSessionProvider>
    </LanguageProvider>
  );
}
